module.exports = __webpack_public_path__ + "static/media/dev-expectations.e9f7f67b.png";